<template>
    <div class="dropdown float-left">
        <small class="text-green" v-if="company.vista_customer_id">Company synced with Vista</small>
        <button type="button" :disabled="vistaLoading"
                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                id="vistaOptionDropDown" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false"
                @click="onDropdownOpened">
            <i v-if="vistaLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
            Vista Options <i class="fa fa-caret-down mx-1"></i>
        </button>

        <div class="standard-dropdown dropdown-menu dropdown-menu-right vista-dropdown-menu" aria-labelledby="vistaOptionDropDown">
            <button v-if="canErpCreate" :title="vistaConnectBtnTitle" type="button" class="dropdown-item py-2 custom-tooltip" :disabled="erpConnectionId && (!vistaConnectionData.vistaCompanyMapping || vistaConnectionData.vistaCompanyMapping.direction === 'one-way-followup' || company.vista_customer_id)" @click.prevent.stop="connectOrUpdateVistaCompany('connect')">
                Connect/Push to Vista
            </button>
            <span v-if="canErpUpdate">
                <button :title="vistaConnectUpdateBtnTitle" v-if="vistaConnectionData.checkContactMappedField && companyContactVistaHistory" type="button" class="dropdown-item py-2 custom-tooltip" :disabled="!company.vista_customer_id || (erpConnectionId && (!vistaConnectionData.vistaCompanyMapping || vistaConnectionData.vistaCompanyMapping.direction === 'one-way-followup'))" @click.prevent.stop="pushOtherContactToVista">
                    Update Customer on Vista
                </button>
                <button :title="vistaConnectUpdateBtnTitle" v-else type="button" class="dropdown-item py-2custom-tooltip" :disabled="!company.vista_customer_id || (erpConnectionId && (!vistaConnectionData.vistaCompanyMapping || vistaConnectionData.vistaCompanyMapping.direction === 'one-way-followup'))" @click.prevent.stop="connectOrUpdateVistaCompany('update')">
                    Update Customer on Vista
                </button>
            </span>
            <button v-if="canErpUpdate" :title="vistaPushOtherBtnTitle" type="button" class="dropdown-item py-2 custom-tooltip" :disabled="erpConnectionId && (!vistaConnectionData.vistaCompanyMapping || vistaConnectionData.vistaCompanyMapping.direction === 'one-way-followup' || !company.vista_customer_id || !vistaConnectionData.checkContactMappedField)" @click.prevent.stop="pushOtherContactToVista">
                Push another Contact
            </button>
            <button v-if="canErpSync" :title="vistaSyncBtnTitle" type="button" class="dropdown-item py-2 custom-tooltip" :disabled="erpConnectionId && (!vistaConnectionData.vistaCompanyMapping || vistaConnectionData.vistaCompanyMapping.direction === 'one-way-third-party')" @click.prevent="syncCompanyFromVista('sync')" >
                Sync from Vista
            </button>
        </div>

        <div class="modal" id="selectCompanyContactForVistaModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ selectCompanyContactForVistaModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('selectCompanyContactForVistaModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select contact to push to Vista</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="contacts"
                                    v-model="selectedCompanyContactForVista"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="selectedCompanyContactForVista && selectedCompanyContactForVista.vista_customer_no" class="text-sm mb-3 text-green">The contact is synced already</div>
                        <div v-if="company.vista_customer_id && this.selectedCompanyContactForVista && !selectedCompanyContactForVista.vista_customer_no" class="text-sm text-danger">Note: This company is already synced with a Vista customer. Pushing a different contact will replace the Vista customer with the newly selected contact.</div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('selectCompanyContactForVistaModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushCustomerToVista" :disabled="!this.selectedCompanyContactForVista || (this.selectedCompanyContactForVista && this.selectedCompanyContactForVista.vista_customer_no)">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateVistaCustomerModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateOrSyncVistaCustomerModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{updateVistaModalBody}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('updateVistaCustomerModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateCustomerToVista()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncVistaCustomerModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateOrSyncVistaCustomerModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this company and contact, with info form the synced Vista customer.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('syncVistaCustomerModal')">Cancel</button>
                        <button v-if="company.vista_customer_id" type="button" class="btn btn-primary" @click.prevent="syncContactFromVista()">Confirm</button>
<!--                        <button v-else-if="!company.erp_connection_id && !erpConnectionId" type="button" class="btn btn-primary" @click.prevent="selectConnectionBeforeSync()">Confirm</button>-->
                        <button v-else type="button" class="btn btn-primary" @click.prevent="closeVistaModal('syncVistaCustomerModal'); openVistaModal('syncCompanyContactFromVistaModal')">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncCompanyContactFromVistaModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ syncCompanyContactFromVistaModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncCompanyContactFromVistaModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromVistaStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Vista customer to sync this company with</label>
                                <div v-if="fetchingVistaCustomers" class="spinner text-sm text-teal">
                                    Fetching customers from vista...
                                </div>
                                <multiselect
                                    v-model="selectedVistaCustomer"
                                    :options="customersFromVista"
                                    @search-change="onSyncVistaInput"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Vista customer..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncCompanyContactFromVistaModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaCustomer" @click.prevent="() => syncFromVistaStepTwo = true" v-if="vistaConnectionData.checkContactMappedField">Next</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaCustomer" @click.prevent="saveSyncedVistaCustomer" v-else>Confirm</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the contact you would like the Vista customer to be synced with</label>
                                <multiselect
                                    v-model="selectedFollowupContact"
                                    :options="contacts"
                                    label="name"
                                    track-by="id"
                                    :multiple="false"
                                    placeholder="Select Followup contact..."
                                    :closeOnSelect="true"
                                ></multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncCompanyContactFromVistaModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedFollowupContact || !selectedVistaCustomer" @click.prevent="saveSyncedVistaCustomer">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="selectConnectionForVista" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Connection</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('selectConnectionForVista')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select a Vista Connection to Proceed</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="erpConnections"
                                    v-model="selectedConnection"
                                    label="name"
                                    placeholder="Search and select a connection..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                    @input="fetchVistaConnectionData"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="vistaErrorMessage" class="col-12">
                            <p class="text-danger">Note: {{ vistaErrorMessage }}</p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('selectConnectionForVista')">Cancel</button>
                        <button v-if="syncingFromVista" type="button" class="btn btn-primary"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="handleVistaSyncSelection()"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>
                            <span v-else>Next</span></button>
                        <button v-else type="button" class="btn btn-primary"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="connectOrUpdateVistaCompany"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>
                            <span v-else>Next</span></button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
    name: 'company-vista',
    components: {Multiselect},
    props: ['company', 'contacts', 'erpConnections', 'companyContactVistaHistory', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    data() {
        return {
            vistaLoading: false,
            syncingFromVista: false,
            selectedConnection: null,
            erpConnectionId: null,
            existingVistaCustomer: null,
            selectedCompanyContactForVista: null,
            updateVistaModalBody: '',
            customersFromVista: [],
            selectedVistaCustomer: null,
            selectedFollowupContact: null,
            syncFromVistaStepTwo: false,
            fetchingVistaCustomers: false,
            vistaConnectionData:{
                vistaCompanyMapping: null,
                checkContactMappedField: null,
                erpSyncSettings: null
            },
            selectedVistaAction: null,
            vistaConnectBtnTitle: '',
            vistaConnectUpdateBtnTitle: '',
            vistaSyncBtnTitle: '',
            vistaPushOtherBtnTitle: '',
            loadingVistaData: false,
            vistaErrorMessage: false,
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
    },
    mounted() {
    /*    if(this.vistaCompanyMapping){
            if(this.vistaCompanyMapping.field_json){
                let vistaFields = JSON.parse(this.vistaCompanyMapping.field_json);
                if(vistaFields.fieldMappings.length > 0){
                    let checkContactObj = vistaFields.fieldMappings.map(function(field){
                        if(field.followUpObject == 'CompanyContact' && field.status){
                            return field;
                        }
                    })
                    checkContactObj = checkContactObj.filter(function(contact){
                        return contact !== null && contact !== undefined;
                    })

                    if(checkContactObj.length === 0){
                        this.checkContactMappedField = false;
                    }
                }
            }
        }*/
        if(this.erpConnections.length == 1){
            this.erpConnectionId = this.company.erp_connection_id ? this.company.erp_connection_id : this.erpConnections[0].id;
        }else{
            this.erpConnectionId = this.company.erp_connection_id ?? null;

        }
        // this.erpConnectionId = this.company.erp_connection_id ?? (this.erpConnections.length == 1 ? this.erpConnections[0].id : null);

        if(this.erpConnectionId){
            this.fetchVistaConnectionData();
        }
        $(document).ready(function() {
            $('.custom-tooltip').tooltip();
        });
    },
    methods: {
        onDropdownOpened() {
            // Delay refresh slightly to avoid DOM focus/blur conflict
            this.$nextTick(() => {
                $('.custom-tooltip').tooltip('dispose');
                $('.custom-tooltip').tooltip({
                    trigger: 'hover',
                    placement: 'top',
                    container: 'body'
                });
            });
        },
        async fetchVistaConnectionData(validateAction = true, connectionId = null) {
            if(connectionId){
                this.erpConnectionId = connectionId;
            }
            if (!this.selectedConnection && !this.erpConnectionId) {
                return;
            }
            this.vistaErrorMessage = "";
            this.loadingVistaData = true;
            this.vistaLoading = true;
            try {

                const response = await axios.post(route('api.vista.get-company-mappings-data'), {
                    connectionId: this.selectedConnection ? this.selectedConnection.id : (this.erpConnectionId ?? null)
                });

                if (response.data && response.data.status === "success") {
                    const vistaData = response.data;

                    // Update the state safely
                    this.$nextTick(()=>{

                        this.vistaConnectionData = {
                            vistaCompanyMapping: vistaData.vistaCompanyMapping ?? false, // Check if mapping exists
                            checkContactMappedField: vistaData.checkContactMappedField ?? false, // Check if mapping exists
                            erpSyncSettings: vistaData.erpSyncSettings ?? null, // Check if mapping exists

                        };
                        if(vistaData.checkContactMappedField){
                            Bus.$emit('vistaCheckContactMappedFieldChanged',this.vistaConnectionData);
                        }
                        if(validateAction){
                            this.validateVistaActions();
                        }
                        this.setVistaButtonTitles();
                    })
                } else {
                    this.resetVistaProjectData();
                }
            } catch (error) {
                this.resetVistaProjectData();
            }finally {
                this.loadingVistaData = false; // Stop Loader after API completes
                this.vistaLoading = false; // Stop Loader after API completes
            }
        },
        validateVistaActions() {
            this.vistaErrorMessage = "";
            if (!this.vistaConnectionData.vistaCompanyMapping) {
                this.vistaErrorMessage = "Please map or enable Company - AR Customers in settings and try again";
                return;
            }

            if (this.vistaConnectionData.vistaCompanyMapping && this.vistaConnectionData.vistaCompanyMapping.direction === "one-way-followup" && (this.selectedVistaAction === "connect" || this.selectedVistaAction === "update")) {
                this.vistaErrorMessage = "This module is not set to push from Followup. Please change the direction in settings to connect or update";
                return;
            }

            if (this.vistaConnectionData.vistaCompanyMapping && this.vistaConnectionData.vistaCompanyMapping.direction === "one-way-third-party" && this.selectedVistaAction === "sync") {
                this.vistaErrorMessage = "This module is not set to sync from Vista. Please change the direction in settings to sync.";
                return;
            }
        },
        resetVistaProjectData() {
            this.vistaConnectionData = {
                vistaCompanyMapping: false,
                checkContactMappedField: true
            };
        },
        selectConnectionBeforeSync() {
            this.syncingFromVista = true;
            this.closeVistaModal("syncVistaCustomerModal");
            this.openVistaModal("selectConnectionForVista");
        },
        handleVistaSyncSelection() {
            if (!this.selectedConnection) return;

            this.erpConnectionId = this.selectedConnection.id; // Store selected connection
            this.syncingFromVista = false;

            this.closeVistaModal("selectConnectionForVista");
            // this.openVistaModal("syncCompanyContactFromVistaModal");
            this.openVistaModal('syncVistaCustomerModal')
        },
        connectOrUpdateVistaCompany(action){
            let self = this;
            self.selectedVistaAction = action;
            if(!self.erpConnectionId && self.selectedConnection == null && !self.company.erp_connection_id){
                self.openVistaModal('selectConnectionForVista');
                return;
            }

            if(!self.erpConnectionId){
                self.erpConnectionId = self.selectedConnection?.id ?? self.company.erp_connection_id;
            }
            self.selectedConnection = null;

            self.closeVistaModal('selectConnectionForVista');
            if(self.company.vista_customer_id && self.vistaConnectionData.checkContactMappedField){
                self.updateVistaModalBody = 'This will replace some of the customer info on the Vista Customer record. Are you sure you want to update the customer on Vista?';
                self.openVistaModal('updateVistaCustomerModal');
            }else if(this.vistaConnectionData.checkContactMappedField){
                let payload = {'company': self.company, type: 'company', connectionId: self.erpConnectionId};
                self.vistaLoading = true;
                axios.post(route('api.company.connect-customer-on-vista'), payload).then((response) => {
                    self.vistaLoading = false;
                    self.company.vista_customer_id = response.data.vista_customer_id
                    if(response.data.status == 'success'){
                        self.getToast(3000).fire({type: 'success',title: response.data.message});
                        self.$parent.fetchContacts();

                    }else if(self.vistaConnectionData.checkContactMappedField){
                        self.openVistaModal('selectCompanyContactForVistaModal');
                    }else if(!self.vistaConnectionData.checkContactMappedField){
                        this.pushCompanyToVista();
                    }
                });
            }else if(!self.vistaConnectionData.checkContactMappedField){
                this.pushCompanyToVista();
            }
        },
        pushCompanyToVista(){
            let self = this;
            let payload = {'company': self.company, type: 'company', message: 'update', connectionId: self.erpConnectionId};
            self.vistaLoading = true;
            axios.post(route('api.company.create-company-on-vista'), payload).then((response) => {
                self.vistaLoading = false;
                this.closeVistaModal('selectCompanyContactForVistaModal');
                if(response.data.hasOwnProperty('companyNameFound')){
                    if(response.data.companyNameFound){
                        self.existingVistaCustomer = response.data.vistaCustomer;
                        Swal.fire({
                            title: 'Customer found on Vista',
                            text: response.data.message,
                            type: 'warning',
                            showCancelButton: false,
                            showConfirmButton: false,
                            confirmButtonColor: '#ff0000',
                            confirmButtonText: 'Connect with selected contact',
                            html: `
                            <p>`+response.data.message+`</p>
                            <br>
                            <button type="button" id="cancelBtn" class="btn btn-secondary">Cancel</button>
                            <button type="button" id="confirmBtn" class="btn btn-primary" style="background-color:#ff0000;">Connect with selected contact</button>`,
                            onBeforeOpen: () => {
                                const confirmBtn = document.querySelector('#confirmBtn')
                                const cancelBtn = document.querySelector('#cancelBtn')

                                confirmBtn.addEventListener('click', () => {
                                    Swal.close();
                                    this.connectExistingCustomer(contact);
                                    return false;
                                })

                                cancelBtn.addEventListener('click', () => {
                                    Swal.close();
                                    return false;
                                })
                            }
                        })
                    }
                    return false;
                }

                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.company.vista_customer_id = response.data.vista_customer_id
                    self.selectedCompanyContactForVista = null;
                    window.location.reload();

                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },
        syncContactFromVista(){
            let self = this;
            let checkAlreadySyncedContact = false;
            let syncedContact = null;

            self.contacts.forEach(item => {
                if(item.vista_customer_no){
                    checkAlreadySyncedContact = true;
                    syncedContact = item;
                }
            });
            if(checkAlreadySyncedContact && syncedContact){
                let payload = {
                    vistaCustomer: null,
                    contact: syncedContact,
                    type: 'company',
                    connectionId: self.erpConnectionId
                }
                self.vistaLoading = true;
                axios.post(route('api.company.sync-customers-from-vista'), payload).then((response) => {
                    self.closeVistaModal('syncVistaCustomerModal');
                    self.vistaLoading = false;
                    if(response.data.status == 'success'){
                        self.getToast(3000).fire({type: 'success',title: response.data.message});
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);
                    }else{
                        self.getToast(2000).fire({type: 'error',title: response.data.message});
                    }
                });
            }else{
                let payload = {
                    companyId: this.company.id,
                    type: 'company',
                    connectionId: self.erpConnectionId
                }
                self.vistaLoading = true;
                axios.post(route('api.company.sync-company-from-vista'), payload).then((response) => {
                    self.closeVistaModal('syncVistaCustomerModal');
                    self.vistaLoading = false;
                    if(response.data.status == 'success'){
                        self.getToast(3000).fire({type: 'success',title: response.data.message});
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);
                    }else{
                        self.getToast(2000).fire({type: 'error',title: response.data.message});
                    }
                });
            }

        },
        pushCustomerToVista(){
            let self = this;
            let payload = {'company': self.company, 'contact': self.selectedCompanyContactForVista, type: 'company', connectionId: self.erpConnectionId};
            if(self.selectedCompanyContactForVista && self.company.vista_customer_id){
                self.openVistaModal('updateVistaCustomerModal');
                // this.updateCustomerToVista(this.selectedCompanyContactForVista);
            }else{
                self.vistaLoading = true;
                axios.post(route('api.company.create-customer-on-vista'), payload).then((response) => {
                    // $('.push-to-vista-loader-'+contact.id).hide();
                    self.vistaLoading = false;
                    this.closeVistaModal('selectCompanyContactForVistaModal');
                    if(response.data.hasOwnProperty('companyNameFound')){
                        if(response.data.companyNameFound){
                            self.existingVistaCustomer = response.data.vistaCustomer;
                            Swal.fire({
                                title: 'Customer found on Vista',
                                text: response.data.message,
                                type: 'warning',
                                showCancelButton: false,
                                showConfirmButton: false,
                                confirmButtonColor: '#ff0000',
                                confirmButtonText: 'Connect with selected contact',
                                html: `
                                <p>`+response.data.message+`</p>
                                <br>
                                <button type="button" id="cancelBtn" class="btn btn-secondary">Cancel</button>
                                <button type="button" id="confirmBtn" class="btn btn-primary" style="background-color:#ff0000;">Connect with selected contact</button>`,
                                onBeforeOpen: () => {
                                    const confirmBtn = document.querySelector('#confirmBtn')
                                    const cancelBtn = document.querySelector('#cancelBtn')

                                    confirmBtn.addEventListener('click', () => {
                                        Swal.close();
                                        this.connectExistingCustomer(contact);
                                        return false;
                                    })

                                    cancelBtn.addEventListener('click', () => {
                                        Swal.close();
                                        return false;
                                    })
                                }
                            })
                        }
                        return false;
                    }

                    if(response.data.status == 'success'){
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        self.company.vista_customer_id = response.data.vista_customer_id
                        self.selectedCompanyContactForVista = null;
                        self.$parent.fetchContacts();

                    }else{
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            }
        },
        updateCustomerToVista(){
            let self = this;
            let contact = null;
            let pushingNewContact = false
            if(self.selectedCompanyContactForVista){
                contact = self.selectedCompanyContactForVistaf
                pushingNewContact = true;
            }else{
                contact = self.contacts.find(contact => contact.vista_customer_no !== null)
            }

            let payload = {'company': self.company, 'contact': contact, 'pushingNewContact': pushingNewContact,  type: 'company', connectionId: self.erpConnectionId};

            if(this.company.agave_customer_no){
                payload.companyAgaveCustomerNumber = 'companyHasAgaveCustomerNumber';
            }

            self.vistaLoading = true;
            self.closeVistaModal('updateVistaCustomerModal');
            self.closeVistaModal('selectCompanyContactForVistaModal');
            axios.post(route('api.company.update-customer-on-vista'), payload).then((response) => {

                self.vistaLoading = false;
                self.selectedCompanyContactForVista = null;

                if(response.data.status == 'success'){
                    self.getToast(3000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.$parent.fetchContacts();

                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        pushOtherContactToVista(){
            let self = this;
            self.updateVistaModalBody = 'Are you sure you want to replace the existing Vista customer with the new contact?';
            self.openVistaModal('selectCompanyContactForVistaModal')
        },
        onSyncVistaInput(value) {
            if (value.length >= 3) {
                this.fetchingVistaCustomers = true;
                this.debouncedFilterOptions(value);
            }
        },
        saveSyncedVistaCustomer(){
            let self = this;
            let payload = {};
            if(this.vistaConnectionData.checkContactMappedField){
                // checkContactMappedField == true , means contact fields are not mapped in Company <> Customers module
                payload = {
                    vistaCustomer: self.selectedVistaCustomer,
                    contact: self.selectedFollowupContact,
                    type: 'company',
                    connectionId: self.erpConnectionId
                }
            }else{
                // checkContactMappedField == false , means contact fields are mapped in Company <> Customers module
                payload = {
                    vistaCustomer: self.selectedVistaCustomer,
                    companyId: self.company.id,
                    type: 'company',
                    mapping: 'withoutContact',
                    connectionId: self.erpConnectionId
                }
            }
            self.vistaLoading = true;
            axios.post(route('api.company.sync-customers-from-vista'), payload).then((response) => {
                self.closeVistaModal('syncCompanyContactFromVistaModal');
                self.vistaLoading = false;
                if(response.data.status == 'success'){
                    self.company.vista_customer_id = response.data.vista_customer_id
                    self.getToast(3000).fire({type: 'success',title: response.data.message});
                    self.$parent.fetchContacts();
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        filterOptions(input) {
            let self = this;
            axios.post(route('api.company.fetch-customers-from-vista'), {search: input, connectionId: this.erpConnectionId}).then((response) => {
                self.fetchingVistaCustomers = false;
                if(response.data.status == 'success'){
                    self.customersFromVista = response.data.vistaCustomers;
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        connectExistingCustomer(contact){
            this.$nextTick(() => {
                let payload = {
                    contact: contact,
                    vistaCustomer: this.existingVistaCustomer,
                    connectionId: this.erpConnectionId
                };
                axios.post(route('api.company.connect-existing-customer-on-vista'), payload).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.$parent.fetchContacts();
                });
            });
        },
        openVistaModal(modalId){
            if(modalId === 'syncCompanyContactFromVistaModal'){
                this.syncFromVistaStepTwo = 0;
                this.selectedVistaCustomer = null;
                this.selectedFollowupContact = null;
            }
            if(this.contacts.length == 0 && this.vistaConnectionData.checkContactMappedField){
                this.getToast().fire({
                    type: 'error',
                    title: 'No contacts added to this company'
                });

                return false;
            }
            $('#'+modalId).modal('show');
        },
        closeVistaModal( modalId){
            if(modalId === 'syncCompanyContactFromVistaModal'){
                this.selectedVistaCustomer = null;
                this.selectedFollowupContact = null;
            }
            $('#'+modalId).modal('hide');
        },
        setVistaButtonTitles() {
            if(!this.vistaConnectionData.vistaCompanyMapping){
                this.vistaConnectBtnTitle = "Please map Company & Customers in settings and try again";
                this.vistaConnectUpdateBtnTitle = "Please map Company & Customers in settings and try again";
                this.vistaPushOtherBtnTitle = "Please map Company & Customers in settings and try again";
                this.vistaSyncBtnTitle = "Please map Company & Customers in settings and try again";

            }else if(this.vistaConnectionData.vistaCompanyMapping && this.vistaConnectionData.vistaCompanyMapping.direction === 'one-way-followup'){
                if(!this.company.vista_customer_id){
                    this.vistaConnectBtnTitle = "This module is not set to push from Followup. Please change the direction in the settings to connect.";
                }
                this.vistaConnectUpdateBtnTitle = "This module is not set to update from Followup. Please change the direction in the settings to update.";
                this.vistaPushOtherBtnTitle = "This module is not set to push from Followup. Please change the direction in the settings to push other contact.";

            }else if(this.vistaConnectionData.vistaCompanyMapping && this.vistaConnectionData.vistaCompanyMapping.direction === 'one-way-third-party'){
                this.vistaSyncBtnTitle = "This module is not set to sync from Vista. Please change the direction in the settings to sync.";
            }else {
                this.vistaConnectBtnTitle = "";
                this.vistaConnectUpdateBtnTitle = "";
                this.vistaSyncBtnTitle = "";
                this.vistaPushOtherBtnTitle = "";
            }

            this.vistaLoading = false;
        },
        syncCompanyFromVista(action){
            this.selectedVistaAction = action;
            if(!this.erpConnectionId && this.selectedConnection == null && !this.company.erp_connection_id){
                this.syncingFromVista = true;
                this.openVistaModal('selectConnectionForVista');
                return;
            }
            this.openVistaModal('syncVistaCustomerModal')
        },
    },
    computed: {
        selectCompanyContactForVistaModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Connect/Push ('+match.name+')' : 'Connect/Push';
        },
        updateOrSyncVistaCustomerModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - This will over-write the info of an existing Vista Customer ('+match.name+')' : 'WARNING! - This will over-write the info of an existing Vista Customer';
        },
        syncCompanyContactFromVistaModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            if(!this.syncFromVistaStepTwo){
                return match ? 'This company is not synced with a Vista Customer ('+match.name+')' : 'This company is not synced with a Vista Customer';
            }else{
                return match ? 'Select Followup contact ('+match.name+')' : 'Select Followup contact';
            }
        }
    }
}
</script>
<style scoped>
#updateVistaCustomerModal .modal-header, #updateVistaCustomerModal .modal-footer{
    background: transparent;
    border-bottom: 0;
    border-top: 0;
}
.custom-tooltip{
    pointer-events: all !important;
}
.vista-button-disabled{
    cursor: not-allowed !important;
}
</style>
